import './Results.scss';
import Component from './Results.js';
export default Component;
